


































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class DownloadLink extends Vue {
    @Prop({ type: Boolean, default: false }) disabled!: boolean;
    @Prop({ default: 'icon-file' }) icon!: string;
}
